import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send this data to your backend
    alert('Thank you for your message! We will contact you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="contact-us-page">
      <div className="container">
        <div className="page-title">
          <h1>Contact Us</h1>
          <p>Reach out for trading support and inquiries</p>
        </div>
        
        <div className="contact-container">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>Have questions about our services? Need trading support? Contact us through the form or via our communication channels below.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <h3>Trading Support</h3>
                <p>For trading-related questions and signal support</p>
                <p>Telegram: <a href="https://t.me/upmsignals" target="_blank" rel="noopener noreferrer">@upmsignals</a></p>
                <p>WhatsApp: <a href="https://wa.me/94760776958" target="_blank" rel="noopener noreferrer">+94760776958</a></p>
              </div>
              
              <div className="contact-item">
                <h3>General Inquiries</h3>
                <p>For business and partnership questions</p>
                <p>Email: <a href="mailto:info@upmtraders.com">info@upmtraders.com</a></p>
              </div>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Send Us a Message</h2>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              rows={5}
              required
            ></textarea>
            <button type="submit" className="btn">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;